import { render } from "./ModalTermsAndPolitics.vue?vue&type=template&id=8ed08d82&scoped=true"
import script from "./ModalTermsAndPolitics.vue?vue&type=script&lang=js"
export * from "./ModalTermsAndPolitics.vue?vue&type=script&lang=js"

import "./ModalTermsAndPolitics.vue?vue&type=style&index=0&id=8ed08d82&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\comprodonto_site_v4\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ed08d82"]])

export default __exports__